import React from "react";
import Banner from "../components/images/banner.jpg"
import Logo from "../components/images/brambouwtlogo.png"

export const Header = ({ title, subtitle, id }: { title: string, subtitle: string, id: string }) => {
    return (
      <div className={"section"}>
        <div className="headerdiv blackbg" id={id}>
			<img className="header-background fade-in-banner" src={Banner} />
			<img className="header-logo" src={Logo} />
        </div>
      </div>
    );
  }
